module.exports = __webpack_public_path__ + "img/NewsCenterDetails3_pic1.509e2446.png";